import {useMemo, useState} from 'react';

export enum TableBrowserScreen {
  LISTING = 'LISTING',
  DETAILS = 'DETAILS',
}

export type TableBrowserScreenState =
  | {screen: TableBrowserScreen.LISTING}
  | {screen: TableBrowserScreen.DETAILS; fullTableName: string};

export default function useTableBrowserScreenState(): {
  onOpenListing: () => void;
  onOpenTable: (fullTableName: string) => void;
  screenState: TableBrowserScreenState;
} {
  const [screenState, setScreenState] = useState<TableBrowserScreenState>({
    screen: TableBrowserScreen.LISTING,
  });
  return useMemo(
    () => ({
      onOpenListing: () => {
        setScreenState({screen: TableBrowserScreen.LISTING});
      },
      onOpenTable: (fullTableName: string) => {
        setScreenState({screen: TableBrowserScreen.DETAILS, fullTableName});
      },
      screenState,
    }),
    [screenState, setScreenState]
  );
}
